import styles from './index.module.scss';

export interface MentorCardProps {
  image: string;
  role: string;
  roleColor?: string;
  name: string;
  desc: string;
}

export default function MentorCard({ image, role, roleColor, name, desc }: MentorCardProps) {
  return (
    <article className={styles.card}>
      <img src={image} alt={name} className={styles.image} loading="lazy" />
      <span className={styles.role} style={roleColor ? { color: roleColor } : undefined}>
        {role}
      </span>
      <div className={styles.info}>
        <h3 className={styles.name}>{name}</h3>
        <p className={styles.desc}>{desc}</p>
      </div>
    </article>
  );
}
